module.exports = __webpack_public_path__ + "static/media/greyLikeIcon.7af1644c.svg";